/* B5 — cart drawer "Often bought together": ONE suggestion, never an item already in the cart.
   Source: Shopify product recommendations (complementary first — set in Search & Discovery — then related) for the
   most recently added cart line. Re-rendered whenever the drawer opens or the cart changes. */
(() => {
  const S = window.lpStrings || {};
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const esc = (s) =>
    String(s || '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
  let busy = false;

  async function recs(productId, intent) {
    try {
      const r = await fetch(`${root}recommendations/products.json?product_id=${productId}&limit=8&intent=${intent}`);
      return r.ok ? (await r.json()).products || [] : [];
    } catch (e) {
      return [];
    }
  }

  async function refresh() {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer || busy) return;
    const footer = drawer.querySelector('.drawer__footer');
    let box = drawer.querySelector('.lp-obt');
    if (!box && footer) {
      /* the box always exists once created (hidden when empty) so the observer cannot loop */
      box = document.createElement('section');
      box.className = 'lp-obt';
      box.hidden = true;
      footer.parentNode.insertBefore(box, footer);
    }
    const hide = () => {
      if (box) {
        box.hidden = true;
        box.innerHTML = '';
      }
    };
    busy = true;
    try {
      const cart = await (await fetch(`${root}cart.js`)).json();
      if (!cart.items || !cart.items.length || !footer) return hide();
      const inCart = new Set(cart.items.map((i) => i.product_id));
      const last = cart.items[0];
      let list = await recs(last.product_id, 'complementary');
      if (!list.length) list = await recs(last.product_id, 'related');
      const pick = list.find((p) => p.available && !inCart.has(p.id) && p.price > 0);
      if (!pick) return hide();
      const v = (pick.variants || []).find((x) => x.available) || {};
      const img = pick.featured_image ? `${pick.featured_image}${pick.featured_image.includes('?') ? '&' : '?'}width=120` : '';
      const buy =
        (pick.variants || []).length > 1
          ? `<a class="lp-obt__btn" href="${esc(pick.url)}">${esc(S.choose)}</a>`
          : `<button type="button" class="lp-obt__btn" data-lp-quick-add="${v.id}">${esc(S.add)}</button>`;
      box.hidden = false;
      box.setAttribute('aria-label', S.obtTitle || 'Often bought together');
      box.innerHTML = `<p class="lp-obt__title">${esc(S.obtTitle)}</p>
        <div class="lp-obt__row">
          ${img ? `<img src="${esc(img)}" alt="" width="56" height="56" loading="lazy">` : ''}
          <a class="lp-obt__name" href="${esc(pick.url)}"><span lang="en" translate="no">${esc(pick.vendor)}</span> <bdi>${esc(pick.title)}</bdi></a>
          <strong><bdi>$${(pick.price / 100).toFixed(2)}</bdi></strong>
          ${buy}
        </div>`;
    } catch (e) {
      /* suggestion is optional — never block the cart */
    } finally {
      busy = false;
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    new MutationObserver(() => {
      if (drawer.classList.contains('active') && !drawer.querySelector('.lp-obt')) refresh();
    }).observe(drawer, { attributes: true, attributeFilter: ['class'], childList: true, subtree: true });
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => setTimeout(refresh, 150));
    }
  });
})();
